import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Figure } from "react-bootstrap";
import { MdAttachFile } from "react-icons/md";
import { IoMdOpen, IoMdDocument } from "react-icons/io";
import * as UTILS from "../helpers/Utility";

const ViewDocument = ({ url }) => (
  <>
    <label>Results/Visit Summary</label>
    <Figure className="document">
      <Link to={{ pathname: url }} target="_blank" className="no-style" rel="noopener noreferrer">
        <b>
          Results <IoMdOpen />
        </b>
        <br />
        {UTILS.FileNameFromUrl(url)}
        <br />
      </Link>
    </Figure>
  </>
);

export default ViewDocument;
